document.addEventListener('DOMContentLoaded', () => {
  const tablist = document.querySelector('[role="tablist"]');

  if (!tablist || tablist.querySelectorAll('[role="tab"]').length === 0) return;

  const tabs = tablist.querySelectorAll('[role="tab"]');
  const panels = document.querySelectorAll('[role="tabpanel"]');

  function activateTab(tab) {
    // Désactiver tous les onglets
    tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
      t.classList.remove('news-filters__item--active');
    });

    // Masquer tous les panels
    panels.forEach(panel => {
      panel.hidden = true;
      panel.classList.remove('agenda__content--visible');
    });

    // Activer l’onglet courant
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tab.classList.add('news-filters__item--active');
    tab.focus();

    // Afficher le panel associé
    const panelId = tab.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);

    panel.hidden = false;
    panel.classList.add('agenda__content--visible');
  }

  // Gestion du clic
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });

    // Gestion clavier
    tab.addEventListener('keydown', (e) => {
      let index = Array.from(tabs).indexOf(tab);

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          index = (index + 1) % tabs.length;
          activateTab(tabs[index]);
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          index = (index - 1 + tabs.length) % tabs.length;
          activateTab(tabs[index]);
          break;

        case 'Home':
          e.preventDefault();
          activateTab(tabs[0]);
          break;

        case 'End':
          e.preventDefault();
          activateTab(tabs[tabs.length - 1]);
          break;
      }
    });
  });
});